import React from 'react';
import { Chip } from '@mui/material';

interface StatusChipProps {
  status: string;
  label: string;
  colorMap?: Record<string, 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'>;
}

const defaultColorMap: Record<string, 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  active: 'success',
  inactive: 'default',
  HIGH: 'error',
  MEDIUM: 'warning',
  LOW: 'info',
  SAFE: 'success',
  critical: 'error',
  high: 'error',
  medium: 'warning',
  low: 'info',
};

const StatusChip: React.FC<StatusChipProps> = ({ status, label, colorMap = defaultColorMap }) => {
  const color = colorMap[status] || 'default';

  return <Chip label={label} color={color} size="small" />;
};

export default StatusChip;
